import { getAppUrl } from "../helpers/get_app_url";

export class BaseService {
    appUrl: string;

    constructor() {
        this.appUrl = getAppUrl();
    }
}